import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/* Original name @uswitch/trustyle.slide-reveal */
import * as React from 'react'; // Extra pixels just in case something minor changes and isn't caught by onLoad
// or useEffect

import { jsx as _jsx } from "theme-ui/jsx-runtime";
var buffer = 10;

var usePrevious = function usePrevious(value) {
  var ref = React.useRef();
  React.useEffect(function () {
    ref.current = value;
  });
  return ref.current;
};

var SlideReveal = function SlideReveal(_ref) {
  var open = _ref.open,
      children = _ref.children,
      className = _ref.className,
      _ref$initialOpen = _ref.initialOpen,
      initialOpen = _ref$initialOpen === void 0 ? true : _ref$initialOpen;
  var contentsWrapperEl = React.useRef(null);

  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      height = _React$useState2[0],
      setHeight = _React$useState2[1]; // This is to ensure that the maxHeight is added back to the DOM before it is
  // set to 0 - otherwise the transition doesn't happen


  var _React$useState3 = React.useState(open),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      delayedOpen = _React$useState4[0],
      setDelayedOpen = _React$useState4[1]; // Initial is to make sure that content displays when JS is disabled and that
  // initially opened content doesn't animate open


  var _React$useState5 = React.useState(initialOpen),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      initial = _React$useState6[0],
      setInitial = _React$useState6[1]; // Store whether we're transitioning or not so that when the slider is open
  // and not transitioning, we can remove the maxHeight to reduce the
  // possibility of edge cases causing content to be cropped


  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      transitioning = _React$useState8[0],
      setTransitioning = _React$useState8[1];

  var calculateHeight = function calculateHeight() {
    if (contentsWrapperEl.current === null) {
      console.error('Wrapper element somehow not defined');
      return;
    }

    var height = contentsWrapperEl.current.getBoundingClientRect().height;
    setHeight(height);

    if (initial) {
      setInitial(false);
    }
  };

  var prevOpen = usePrevious(open); // This is also called when `children` changes

  React.useEffect(function () {
    calculateHeight();

    if (prevOpen !== undefined && open !== prevOpen) {
      setTransitioning(true);
    }
  });

  if (delayedOpen !== open) {
    setTimeout(function () {
      return setDelayedOpen(open);
    });
  }

  return _jsx("div", {
    sx: initial || !transitioning && delayedOpen ? {} : {
      maxHeight: delayedOpen ? height + buffer : 0,
      overflow: 'hidden',
      transform: 'max-height 0.4s',
      variant: 'elements.slide-reveal.maxHeight'
    },
    onTransitionEnd: function onTransitionEnd() {
      return setTransitioning(false);
    } // This updates the height when child images finish loading
    ,
    onLoad: calculateHeight,
    className: className,
    children: _jsx("div", {
      ref: contentsWrapperEl,
      children: children
    })
  });
};

export default SlideReveal;
//# sourceMappingURL=index.js.map